<template>
  <BorderWrapper>
    <Carousel
      v-if="carouselImages?.length > 0"
      :carouselImages="carouselImages"
    />
    <CategoriesSectionHome
      :rootCategories="getRootCategories"
      :subCategories="subCategories"
    />
    <ProductsCarousel
      v-if="hotProductsList.length > 0"
      @updateProduct="updateProduct"
      @updatePartRquestAddToPriceList="updatePartRquestAddToPriceList"
      :isAuthenticated="isAuthenticated"
      :products="hotProductsList"
      :breakpoints="breakpoints"
      :priceListId="getCustomerPriceListId"
      :ShowTitle="true"
      :bannerImage="hotBannerImage"
    />
    <ProductsCarousel
      v-if="discountedProductsList.length > 0"
      @updateProduct="updateProduct"
      @updatePartRquestAddToPriceList="updatePartRquestAddToPriceList"
      :isAuthenticated="isAuthenticated"
      :products="discountedProductsList"
      :breakpoints="breakpoints"
      :priceListId="getCustomerPriceListId"
      :ShowTitle="true"
      :bannerImage="saleBannerImage"
      bannerTitle="מוצרים במבצע"
      bannerDesc="המוצרים במבצע באתר"
    />
    <AboutSectionHome />
    <FormSectionHome />
  </BorderWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import Carousel from "../../components/helpers/Carousel.vue";
import BorderWrapper from "../UI/BorderWrapper.vue";
import CategoriesSectionHome from "../helpers/homePage/CategoriesSectionHome.vue";
import AboutSectionHome from "../helpers/homePage/AboutSectionHome.vue";
import ProductsCarousel from "../helpers/homePage/ProductsCarousel.vue";
import FormSectionHome from "../helpers/homePage/FormSectionHome.vue";
import AlertService from "../../services/AlertService";
import config from "@/config";
export default {
  components: {
    BorderWrapper,
    Carousel,
    CategoriesSectionHome,
    ProductsCarousel,
    AboutSectionHome,
    FormSectionHome,
  },
  data() {
    return {
      productsCarousel: [],
      hotProductsList: [],
      discountedProductsList: [],
      hotBannerImage: null,
      saleBannerImage: "/images/sale-banner.svg",
      carouselImages: [{}],
      subCategories: [],
      breakpoints: {
        200: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        768: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1600: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  async created() {
    await this.getPromotions();
    await this.getSubCategories();
    var res = await this.$store.dispatch("Parts/fetchCarouselProducts");

    this.productsCarousel = res.parts;

    var hotRes = await this.$store.dispatch("Parts/fetchHotProducts");
    this.hotProductsList = hotRes.parts;

    var discountedRes = await this.$store.dispatch(
      "Parts/fetchDiscountedProducts",
    );
    this.discountedProductsList = discountedRes?.parts || [];

    const rootCats = this.getRootCategories;
    const hotImg =
      rootCats?.find((c, i) => i === 1 && c.image)?.image ||
      rootCats?.find((c) => c.image)?.image;
    if (hotImg)
      this.hotBannerImage = hotImg.startsWith("http")
        ? hotImg
        : `${config.baseURL}/${hotImg}`;
  },
  methods: {
    async getSubCategories() {
      try {
        const categoriesRes = await this.$store.dispatch(
          "Category/getCategories",
          {},
        );
        this.subCategories = categoriesRes.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getPromotions() {
      try {
        const response = await AlertService.promotions();
        if (response?.data) this.carouselImages = response.data;
        else this.carouselImages = [{}];
      } catch (error) {
        console.log(error);
      }
    },
    updatePartRquestAddToPriceList(partId) {
      const productIndex = this.productsCarousel.findIndex(
        (product) => product.part === partId,
      );
      if (productIndex !== -1) {
        this.productsCarousel[productIndex] = {
          ...this.productsCarousel[productIndex],
          sentPriceListRequest: true,
        };
      }
    },
    async updateProduct(obj) {
      if (!obj?.product || this.isQuantityBtnDisable) return;

      this.isQuantityBtnDisable = true;
      const { product, quantity } = obj;
      const lineOrdi = this.getLineByPart(product.part);

      const line = {
        Part: { ...product },
        quant: quantity,
        ...(lineOrdi && { ordi: lineOrdi }),
      };

      if (quantity > 0) {
        await this.$store.dispatch("Orders/updateCart", line);
      } else if (line.ordi) {
        await this.$store.dispatch("Orders/removeProductFromCart", line);
      }

      this.isQuantityBtnDisable = false;
    },
  },
  computed: {
    ...mapGetters({
      getRootCategories: "Category/getRootCategories",
      getLineByPart: "Orders/getLineByPart",
      getCarouselProducts: "Parts/getCarouselProducts",
      getCustomerPriceListId: "AuthModule/getCustomerPriceListId",
      isAuthenticated: "AuthModule/isAuthenticated",
    }),
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-size: 20px;
  margin: 0;
  margin-top: 100px;
  margin-bottom: 10px;
  font-weight: 600;
}
h2 {
  font-size: 30px;
  margin: 0;
  color: $primaryColor;
}
.col {
  float: unset;
}
img {
  width: auto;
  height: 340px;
  margin: 0 auto !important;
  display: block;
}
</style>
